/** @jsx h */
import { h } from 'preact'

const FilterIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='25' height='17.5' viewBox='0 0 25 17.5' aria-hidden='true'>
    <g fill='none' stroke='#000' transform='translate(4.5)'>
      <circle stroke='none' cx='4' cy='4' r='4' />
      <circle fill='none' cx='4' cy='4' r='3.5' />
    </g>
    <g stroke='#000' fill='none' transform='translate(12.5 9.5)'>
      <circle stroke='none' cx='4' cy='4' r='4' />
      <circle fill='none' cx='4' cy='4' r='3.5' />
    </g>
    <rect width='5' height='1' transform='translate(0 3.667)' />
    <rect width='5' height='1' transform='translate(20 12.833)' />
    <rect width='13' height='1' transform='translate(12 3.667)' />
    <rect width='13' height='1' transform='translate(0 12.833)' />
  </svg>
)

export default FilterIcon
